import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DocumentsSections } from "../../../domain/enums/DocumentsSectionsEnum";
import { enumToSelectProps } from "../../../tools/EnumTools";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";

interface DocumentsSidebarProps {
    documentsSection: DocumentsSections;
    setDocumentsSection: (value: DocumentsSections) => void;
}

const DocumentsSidebar: FC<DocumentsSidebarProps> = (props) => {
    const { t } = useTranslation();
    const { moreOrEqual800 } = useScreenSize();

    return (
        <>
            {moreOrEqual800 && (
                <div className="sticky top-[40px] flex flex-col gap-5 dmax2:gap-3 w-[350px] min-w-[350px] td3:w-[250px] td3:min-w-[250px] h-full">
                    {enumToSelectProps(DocumentsSections, "documentsSections").map((section, index) => (
                        <div
                            key={`documents-section-${index}`}
                            onClick={() => props.setDocumentsSection(section.value)}
                            className={`H20B dmax2:H14B text-textFaded hover:text-textWhite border-b hover:border-b-2 border-b-[rgba(122,122,126,1)] hover:border-b-[rgba(241,241,241,1)] px-2.5 pb-5 dmax2:pb-3 transition duration-300 cursor-pointer ${
                                props.documentsSection === section.value &&
                                "text-textWhite border-b-2 border-b-[rgba(241,241,241,1)]"
                            }`}
                        >
                            {t(`${section.labelKey}`)}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default DocumentsSidebar;
